<template>
  <div class="provider-type-picker" v-click-outside="doHideDropdown">
    <div class="dropdown" :class="{'show': showDropdown}">
      <button
        class="btn btn-primary btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        aria-haspopup="true"
        aria-expanded="false"
        ref="Dropdown"
        @click="doShowDropdown"
      >{{$t('local_picker.type.name')}}: {{componentTitle}}</button>
      <div class="dropdown-menu dropdown-menu-right" :class="{'show': showDropdown}">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="head">{{$t('local_picker.type.type')}}</div>
              <div
                class="selection-wraper"
                v-for="item in values.types"
                :key="item.value"
              >
                <button
                  type="button"
                  class="btn"
                  :class="{'btn-outline-secondary': (item.value!==model.type), 'btn-primary': (item.value==model.type)}"
                  @click="selectType(item)"
                >{{item.title}}</button>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-6">
              <button type="button" class="btn btn-outline-secondary col-12" @click="resetAll">RESET</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-info col-12" @click="apply">APPLY</button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.provider-type-picker {
  display: inline-block;
}
.dropdown-menu {
  min-width: 200px;
  -webkit-box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  padding: 10px;
  .head {
    font-weight: bold;
    padding-bottom: 10px;
  }
  .selection-wraper {
    padding-bottom: 10px;
    button {
      font-size: 0.9em;
      font-weight: bold;
    }
  }
}
@media (max-width: 991.98px) {
  .dropdown-menu {
    position: fixed;
    top: 15px;
    left: 15px;
    bottom: 15px;
    right: 15px;
    min-width: 100px;
  }
}
</style>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "ProviderTypePicker",
  directives: { ClickOutside },
  data() {
    var model = {
      type: ""
    };

    if (this.value) {
      model.type = this.value.type || model.type;
    }

    return {
      showDropdown: false,
      model,
      values: {
        types: [
          {
            value: "",
            title: this.$t('all')
          },
          {
            value: "company",
            title:  this.$t('company')
          },
          {
            value: "individual",
            title: this.$t('individual')
          }
        ]
      }
    };
  },
  props: {
    value: String
  },
  computed: {
    componentTitle() {
      if (this.model.type === "") {
        // return "All";
        return this.$t('all');
      }
      if (this.model.type === "company") {
        // return "Company";
        return this.$t('company');
      }
      if (this.model.type === "individual") {
        // return "Individual";
        return this.$t('individual');
      }
      return "";
    }
  },
  methods: {
    doHideDropdown() {
      this.showDropdown = false;
    },
    doShowDropdown() {
      this.showDropdown = true;
    },
    resetAll() {
      this.model.type = "";
      this.doHideDropdown();
      this.$emit("input", this.model.type);
    },
    apply() {
      this.doHideDropdown();
      this.$emit("input", this.model.type);
    },
    selectType(item) {
      this.model.type = item.value;
      console.log(this.model.type);
      this.apply();
    }
  },
  mounted() {
    // const Dropdown = this.$refs.Dropdown;
    // $("body").on("click", function(e) {
    //   if (
    //     !$("li.dropdown.mega-dropdown").is(e.target) &&
    //     $("li.dropdown.mega-dropdown").has(e.target).length === 0 &&
    //     $(".open").has(e.target).length === 0
    //   ) {
    //     $("li.dropdown.mega-dropdown").removeClass("open");
    //   }
    // });
  }
};
</script>